module.exports = __webpack_public_path__ + "static/media/index.cc991774.less";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/GlobalFooter/index.less
// module id = 773
// module chunks = 0